export const deliverables = {
  export: {
    trigger: 'Export',
    copyHeading: 'Copy URLs',
    copyMonth: 'Copy URLs — current month',
    copyAll: 'Copy URLs — all months',
    csvHeading: 'Download CSV',
    csvMonth: 'CSV — current month',
    csvAll: 'CSV — all months',
    copied: 'URLs copied: {{withUrl}} of {{total}} deliverables have a URL',
    downloaded: 'CSV downloaded ({{count}} deliverables)',
    noUrls: 'No deliverable has a URL yet.',
    noItems: 'No deliverables to export.',
    error: 'Export failed. Please try again.',
  },
  overview: {
    title: 'Deliverables',
    description: 'Monthly deliverables tracking per client',
    monthLabel: 'Month',
    columns: {
      organization: 'Client',
      nota: 'Articles',
      optimizacion: 'Optimizations',
      landing: 'Landings',
      backlink: 'Backlinks',
      interaccion_hilo: 'Threads',
    },
    empty: 'No deliverables loaded yet for this month.',
    error: 'Could not load deliverables.',
    loading: 'Loading deliverables…',
    noTarget: 'No target',
    approvedShort: 'Appr.',
    publishedShort: 'Pub.',
  },
  detail: {
    back: 'Back',
    monthLabel: 'Month',
    notFound: 'Client not found.',
    goalsTitle: 'Monthly goals',
    goalsDescription: 'Set how many items you expect to deliver this month.',
    goalsSaveButton: 'Save goals',
    goalsSaving: 'Saving…',
    goalsSaved: 'Goals updated',
    goalsError: 'Could not save goals',
    itemsTitle: 'Deliverables',
    addItem: 'Add deliverable',
    editCount: 'Edit count',
  },
  sections: {
    goalLabel: 'Goal',
  },
  types: {
    nota: { label: 'Articles', short: 'Articles', singular: 'Article' },
    optimizacion: { label: 'Optimizations', short: 'Opt.', singular: 'Optimization' },
    landing: { label: 'Landings', short: 'Landings', singular: 'Landing' },
    backlink: { label: 'Backlinks', short: 'BL', singular: 'Backlink' },
    interaccion_hilo: { label: 'Thread interactions', short: 'Threads', singular: 'Thread interaction' },
  },
  statuses: {
    nota: {
      created: 'Drafted',
      in_client_review: 'In client review',
      approved: 'Approved',
    },
    optimizacion: {
      pending: 'Pending',
      done: 'Done',
    },
    landing: {
      pending: 'Pending',
      done: 'Done',
    },
    backlink: {
      pending: 'Pending',
      done: 'Done',
    },
    interaccion_hilo: {
      pending: 'Pending',
      published: 'Published',
    },
  },
  platforms: {
    reddit: 'Reddit',
    linkedin: 'LinkedIn',
    x: 'X',
    otro: 'Other',
  },
  filter: {
    label: 'Filter by status',
    all: 'All statuses',
  },
  comments: {
    title: 'Team comments',
    placeholder: 'Leave a note for the team…',
    add: 'Add comment',
    empty: 'No comments yet.',
    delete: 'Delete comment',
  },
  missing: {
    title: '{{count}} content plan items without a deliverable',
    syncButton: 'Sync plan',
    syncing: 'Syncing…',
    syncSuccess: 'Created {{count}} deliverables from the plan.',
    syncError: 'Could not sync the content plan.',
  },
  form: {
    title: 'Title',
    titlePlaceholder: 'Enter a title',
    objective: 'Objective',
    objectivePlaceholder: 'What this deliverable aims to achieve',
    url: 'Reference link',
    urlPlaceholder: 'https://…',
    status: 'Status',
    notes: 'Detail',
    notesPlaceholder: 'Deliverable detail',
    owner: 'Owner',
    ownerNone: 'No owner',
    ownerSearch: 'Search person…',
    ownerEmpty: 'No people available.',
    clientDeliveryDate: 'Client delivery date',
    sourceUrl: 'Source URL (backlink)',
    sourceUrlPlaceholder: 'https://media.com/article',
    platform: 'Platform',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteConfirm: 'Delete this deliverable?',
    deleteConfirmDescription: 'This action cannot be undone.',
    createTitle: 'New deliverable',
    editTitle: 'Edit deliverable',
    typeLabel: 'Type',
    required: 'Required field',
    invalidUrl: 'Invalid URL',
  },
  items: {
    empty: 'No deliverables of this type.',
    noneForFilter: 'No deliverables match the filter.',
    edit: 'Edit',
    delete: 'Delete',
    none: '—',
    openUrl: 'Open link',
    expand: 'Expand deliverable',
    collapse: 'Collapse deliverable',
    published: 'Published',
    notPublished: 'Not published',
    markPublished: 'Mark as published',
    markUnpublished: 'Mark as not published',
  },
  setCount: {
    title: 'Edit {{type}} count',
    description: 'Current count: {{count}}. Set how many deliverables exist this month.',
    fieldLabel: 'New count',
    decrement: 'Decrease by one',
    increment: 'Increase by one',
    willCreate: '{{count}} new deliverables will be created.',
    willDelete: 'The last {{count}} deliverables will be deleted. This cannot be undone.',
    noChange: 'No changes from the current value.',
    outOfRange: 'Enter a number between 0 and {{max}}.',
    save: 'Save',
    saving: 'Saving…',
    success: 'Count updated',
    error: 'Could not update the count',
  },
  toasts: {
    itemCreated: 'Deliverable created',
    itemUpdated: 'Deliverable updated',
    itemDeleted: 'Deliverable deleted',
    commentAdded: 'Comment added',
    commentDeleted: 'Comment deleted',
    published: 'Marked as published',
    unpublished: 'Marked as not published',
    error: 'An error occurred',
  },
  client: {
    kicker: 'This month',
    title: 'Deliverables progress',
    subtitle: 'Track the progress of the deliverables your SEO team is producing this month.',
    itemsTitle: 'Deliverables this month',
    empty: 'No deliverables loaded for this month yet.',
    error: 'Could not load progress.',
    approvedCount: '{{count}} approved',
    publishedCount: '{{count}} published',
    fields: {
      objective: 'Objective',
      detail: 'Detail',
      status: 'Status',
      owner: 'Owner',
      deliveryDate: 'Delivery date',
      referenceLink: 'Reference link',
    },
    steps: {
      published: 'Published',
      nota: {
        created: 'Draft',
        in_client_review: 'Sent',
        approved: 'Approved',
      },
      optimizacion: {
        pending: 'Pending',
        done: 'Done',
      },
      landing: {
        pending: 'Pending',
        done: 'Done',
      },
      backlink: {
        pending: 'Pending',
        done: 'Done',
      },
      interaccion_hilo: {
        pending: 'Pending',
        published: 'Published',
      },
    },
  },
}
